import { queryOptions, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { Plan } from '@/common/api/types/adaptivePlanner';
import { associateById } from '@/common/utils/associateById';
import { AdaptivePlannerPlan } from '@/features/planner/api/adaptive-planner/plan';
import { adaptivePlannerQueryKeys } from '@/features/planner/queryKeys/adaptivePlanner';

export const planQueryOptions = ({ enabled, limit }: { enabled?: boolean; limit?: number } = {}) =>
  queryOptions<Plan[]>({
    queryKey: [...adaptivePlannerQueryKeys.plans.all(), { limit }],
    queryFn: () => AdaptivePlannerPlan.getPlans({ limit }),
    enabled: enabled ?? true,
  });

export const useGetPlansQuery = (
  options: Partial<UseQueryOptions<Plan[]>> & { limit?: number } = {},
) => {
  const { limit, ...queryOptions } = options;
  return useQuery({
    ...planQueryOptions({
      enabled: queryOptions.enabled ? queryOptions.enabled === true : true,
      limit,
    }),
    ...queryOptions,
  });
};

export const useGetPlansByIdQuery = (options: Partial<UseQueryOptions<Plan[]>> = {}) => {
  return useQuery({
    ...planQueryOptions({ enabled: options.enabled ? options.enabled === true : true }),
    ...options,
    select: associateById,
  });
};
